module.exports = __webpack_public_path__ + "img/1482522713.da79555e.jpg";